import './AttachmentDetailsPreviewHeader.scss';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faAngleLeft, faAngleRight, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslator } from '@Localization';
import { IconButton } from '@mui/joy';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { useHistory } from 'react-router';
import { EditableAttachmentPreviewHeaderContainer } from '../../../../modules/attachments/rename/ui/header/EditableAttachmentPreviewHeader.container';
import { ImageNavigation } from '../../../components/ImageNavigation';
import { toLocaleDateTimeString } from '../../../helpers/date.helpers';

library.add(faAngleLeft, faAngleRight, faTimes);

interface IProps {
  channels: number;
  closeButtonLink: string;
  createdDate: string;
  current: number;
  downloadSpeed?: number;
  id: string;
  imageHeight: number;
  imageSize: number;
  imageWidth: number;
  isCached: boolean;
  isHighResImageLoading: boolean;
  isLoading: boolean;
  name: string;
  nextLink: string;
  parentId: string;
  previousLink: string;
  total: number;
}

export const AttachmentDetailsPreviewHeader = observer((props: IProps): ReactElement => {
  const { t } = useTranslator();
  const history = useHistory();

  const { total, current, name, id, parentId, nextLink, previousLink, closeButtonLink } = props;

  const attributes = [
    { name: t('image_attribute_size'), value: `${props.imageSize.toFixed(3)} MB` },
    { name: t('image_attribute_resolution'), value: `${props.imageWidth} x ${props.imageHeight}` },
    { name: t('image_attribute_type'), value: `${props.channels} ${t('image_attribute_channels')}` },
    { name: t('image_attribute_status'), value: props.isCached ? t('image_attribute_status_cached') : t('image_attribute_status_not_cached') },
    { name: t('image_attribute_created'), value: toLocaleDateTimeString(props.createdDate) },
    {
      name: t('image_attribute_load_speed'),
      value: props.downloadSpeed ? `${props.downloadSpeed.toFixed(3)} Mbps` : t('image_attribute_load_speed_cached'),
    },
  ];
  return (
    <div className='attachment-image-preview-header'>
      <div className='image-name'>
        <EditableAttachmentPreviewHeaderContainer
          name={name}
          id={id}
          parentId={parentId}
        />
        {!props.isHighResImageLoading && <span className='info'>{attributes.map((a) => `${a.name}: ${a.value}`).join(' | ')}</span>}
      </div>
      <div className='navigation'>
        <ImageNavigation
          current={current}
          total={total}
          nextLink={nextLink}
          previousLink={previousLink}
          isLoading={props.isLoading}
          disabled={false}
        />
        <IconButton
          color='primary'
          variant='solid'
          onClick={() => {
            history.push(closeButtonLink);
          }}
        >
          <FontAwesomeIcon
            icon={faTimes}
            title={t('close')}
          />
        </IconButton>
      </div>
    </div>
  );
});
